<div
	class="tw:fixed tw:z-50 tw:w-full tw:bottom-0 tw:left-0 tw:right-0 tw:px-4 tw:py-2 tw:flex tw:lg:hidden tw:justify-between tw:bg-white"
>
	@if (userRole.isStoresManager()) {
		<app-bottom-menu-item icon="build" routerLinkActive="active" routerLink="/stores-inventory/setup">
			{{ "sideMenu.setup" | translate }}
		</app-bottom-menu-item>

		<app-bottom-menu-item icon="inventory_2" routerLinkActive="active" routerLink="/stores-inventory/inventory-register">
			{{ "sideMenu.inventoryRegister" | translate }}
		</app-bottom-menu-item>

		<app-bottom-menu-item icon="box" routerLinkActive="active" routerLink="/stores-inventory/internal-use-items">
			{{ "sideMenu.itemIssuance" | translate }}
		</app-bottom-menu-item>

		<app-bottom-menu-item icon="article" routerLinkActive="active" routerLink="/stores-inventory/inventory-reports">
			{{ "sideMenu.inventoryReports" | translate }}
		</app-bottom-menu-item>
		@if (userPermissions.canAccessExpenses()) {
		<app-bottom-menu-item (click)="showMore()" icon="more_vert">More</app-bottom-menu-item>
		}
	} @else {
		<app-bottom-menu-item icon="space_dashboard" routerLink="/dashboard" routerLinkActive="active">
			Dashboard
		</app-bottom-menu-item>

		<app-bottom-menu-item icon="groups" routerLink="/students" routerLinkActive="active">
			Students
		</app-bottom-menu-item>

		<app-bottom-menu-item icon="checkbook" routerLink="/invoicing" routerLinkActive="active">
			Invoicing
		</app-bottom-menu-item>

		<app-bottom-menu-item (click)="showMore()" icon="more_vert">More</app-bottom-menu-item>
	}
</div>
